import React from 'react';
import styled from 'styled-components';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

const BreadCrumbContainer = styled.div`
    .breadcrumb-container {
        padding-bottom: 30px;
        ${media.medium`padding-bottom: 70px;`}
        ul {
            padding: 0;
            margin: 0;
            list-style: none;

            li {
                display: inline-block;
                margin-right: 10px;

                a {
                    color: #000;
                }
            }
        }
    }
`;

const BreadCrumb = ({ product }) => {
    return (
        <BreadCrumbContainer>
            <Wrapper className="breadcrumb-container">
                <ul>
                    <li>
                        <a href="#">Shop</a>
                    </li>
                    <li>{'>'}</li>
                    <li>
                        <a href="#">Apparel</a>
                    </li>

                    <li>{'>'}</li>
                    <li>
                        <a href="#">{product.title}</a>
                    </li>
                </ul>
            </Wrapper>
        </BreadCrumbContainer>
    );
};

export default BreadCrumb;
